import React, { Component } from 'react';

import ArtworkCard from './ArtworkCard';
import Artwork from '../../model/artwork';

type ArtworkMasonryProps = {
    artworks: Array<Artwork>;
};

export default class ArtworkMasonry extends Component<ArtworkMasonryProps, {}> {

    render() {

        const { artworks } = this.props;

        return (
            <div>
                <div className="card-columns">
                    {artworks.map((ac) => {
                        return <ArtworkCard artworkData={ac} key={ac.regNum} />;
                    })}
                </div>

            </div >
        );
    }
}
